var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("activator",function(){return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""}},'v-btn',attrs,false),Object.assign(on, _vm.slotEvents)),[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)]}}])},[_c('div',[_vm._v(" "+_vm._s(_vm.tooltip)+" ")])])]},null,{ on: _vm.slotEvents })],2)}
var staticRenderFns = []

export { render, staticRenderFns }